// extracted by mini-css-extract-plugin
module.exports = {"refurbished-A":"A_refurbished-A__reoXH"};